import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

const CardFooter = ({ children, className, tag: Tag }) => (
  <Tag className={classnames('card-footer', className)}>{children}</Tag>
);

CardFooter.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tag: PropTypes.node,
};

CardFooter.defaultProps = {
  children: null,
  className: null,
  tag: 'div',
};

export default CardFooter;
